import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

const Login = lazy(() => import('./pages/Login'));
const Dashboard = lazy(() => import('./pages/Dashboard'));
const ProjectProgress = lazy(() => import('./pages/ProjectProgress'));
const Register = lazy(() => import('./pages/Register'));
const QuoteFill = lazy(() => import('./pages/QuoteFill'));
const LaborFormFill = lazy(() => import('./pages/LaborFormFill'));
const LaborReportSign = lazy(() => import('./pages/LaborReportSign'));
const CreditFill = lazy(() => import('./pages/CreditFill'));
const ResetPassword = lazy(() => import('./pages/ResetPassword'));
const SettlementFill = lazy(() => import('./pages/SettlementFill'));
const LocationSheetPublic = lazy(() => import('./pages/LocationSheetPublic'));
const PublicRegister = lazy(() => import('./pages/PublicRegister'));
const Onboarding = lazy(() => import('./pages/Onboarding'));
const QuoteShared = lazy(() => import('./pages/QuoteShared'));

const Loading = () => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#fff' }}>
    <div style={{ textAlign: 'center' }}>
      <div style={{ width: 32, height: 32, border: '3px solid #f0f0f0', borderTopColor: '#E3000F', borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto 12px' }} />
      <div style={{ fontSize: 13, color: '#999' }}>載入中...</div>
    </div>
  </div>
);

const RequireAuth: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/login" replace />;
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  // Staff with incomplete profile → force onboarding (super_admin skips)
  if (user.role !== 'super_admin' && user.profile_completed === 0) return <Navigate to="/onboarding" replace />;
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/project/:token/progress" element={<ProjectProgress />} />
        <Route path="/quote-fill/:token" element={<QuoteFill />} />
        <Route path="/register/:token" element={<Register />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="/labor-form/:token" element={<LaborFormFill />} />
        <Route path="/labor-fill/:token" element={<LaborFormFill />} />
        <Route path="/labor-report/sign-back/:token" element={<LaborReportSign />} />
        <Route path="/credit/fill/:token" element={<CreditFill />} />
        <Route path="/settlement-fill/:token" element={<SettlementFill />} />
        <Route path="/location-sheet/:token" element={<LocationSheetPublic />} />
        <Route path="/share/quotation/:token" element={<QuoteShared />} />
        <Route path="/signup" element={<PublicRegister />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route
          path="/dashboard/*"
          element={
            <RequireAuth>
              <Dashboard />
            </RequireAuth>
          }
        />
      </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
